import * as React from "react";

export const ShareIcon = (props: any) => (
  <svg
    width={17}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.25.75v16.5h16.5V.75H.25Zm1.5 1.5h13.5v13.5H1.75V2.25ZM11.5 4.5c-.438 0-.805.164-1.102.492-.296.313-.43.688-.398 1.125L6.484 7.875A1.435 1.435 0 0 0 5.5 7.5c-.422 0-.781.148-1.078.445A1.43 1.43 0 0 0 4 9c0 .422.14.781.422 1.078A1.51 1.51 0 0 0 5.5 10.5c.375 0 .703-.125.984-.375L10 11.883c-.031.437.102.82.398 1.148.297.313.657.469 1.079.469.437 0 .796-.14 1.078-.422.297-.297.445-.656.445-1.078 0-.422-.148-.773-.445-1.055A1.393 1.393 0 0 0 11.5 10.5c-.375 0-.703.125-.984.375L7 9.117v-.234l3.516-1.758c.28.25.609.375.984.375.422 0 .773-.14 1.055-.422C12.852 6.781 13 6.422 13 6c0-.422-.148-.773-.445-1.055A1.393 1.393 0 0 0 11.5 4.5Z"
      fill="#333"
    />
  </svg>
);
